import { NotificationService } from 'interfaces/notificationService';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const queryNotificationServices = ({
  ids,
  arns,
  signal,
}: {
  ids?: string[];
  arns?: string[];
  signal?: AbortSignal;
}) => {
  return apiRequestHandlerPromise<NotificationService[]>({
    url: 'notification_services.get',
    method: 'POST',
    data: JSON.stringify({ ids, arns }),
    signal,
  });
};
